import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { isOnMainProductPage } from '@theme/utilities';

class ProductInventory extends HTMLElement {
  /** @type {AbortController | null} */
  #abortController = null;

  connectedCallback() {
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    if (isOnMainProductPage(this)) {
      // On main product page, only listen at document level to avoid duplicate events
      // (events bubble from section to document, causing double-firing)
      document.addEventListener(ThemeEvents.variantUpdate, this.updateInventory, { signal });
    } else {
      // In modals, dialogs, etc., listen at the container level
      const closestSection = this.closest('.shopify-section, dialog');
      closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory, { signal });
    }
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    this.#abortController = null;
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    const data = event.detail?.data;
    if (!data) return;

    if (data.newProduct?.id) {
      this.dataset.productId = String(data.newProduct.id);
    } else if (data.productId !== this.dataset.productId) {
      return;
    }

    const newInventory = data.html?.querySelector?.('product-inventory');

    if (!newInventory || !this.isConnected) return;

    try {
      morph(this, newInventory, { childrenOnly: true });
    } catch {
      // Ignore morph errors (e.g. invalid or detached node)
    }
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
